export default __webpack_public_path__ + "static/media/bg3.a35b43fc.jpg";